'use client'
import {
  LOCATION_QUERY
} from "./chunk-KJDK3CSR.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-HLVUCALY.mjs";
import {
  BUTTON_QUERY
} from "./chunk-OYEMYN5L.mjs";
import {
  CATEGORY_QUERY
} from "./chunk-ZZ3DUO5U.mjs";
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";
import {
  CURRENCY_QUERY
} from "./chunk-PXTWVUHC.mjs";

// src/api/common/event.ts
var EVENT_LIST_QUERY = `
id
title
image11{${IMAGE_QUERY}}
image31{${IMAGE_QUERY}}
slug
price
currency{${CURRENCY_QUERY}}
button {${BUTTON_QUERY}}
category {${CATEGORY_QUERY}}
schedule{${SCHEDULE_QUERY}}
location{${LOCATION_QUERY}}
sellersCollection(limit: 3){
  items{id title}
}
`;

export {
  EVENT_LIST_QUERY
};
//# sourceMappingURL=chunk-V7GHPYJJ.mjs.map